import { render } from "./AddEditStock.vue?vue&type=template&id=6a02fb66&scoped=true"
import script from "./AddEditStock.vue?vue&type=script&lang=js"
export * from "./AddEditStock.vue?vue&type=script&lang=js"

import "./AddEditStock.vue?vue&type=style&index=0&id=6a02fb66&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a02fb66"]])

export default __exports__